import { auditReports } from '@mi-front/api-clients';
import { AuditMatch, DateStr, toDateStr } from '@mi-front/core';
import BroadcastOnPersonalIcon from '@mui/icons-material/BroadcastOnPersonal';
import { Chip, Tooltip } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useActiveStation } from '../../../../core/stations/hooks/useActiveStation';

export function BcrMatchStatus(p: { match: AuditMatch }) {
  const { $t } = useIntl();
  const station = useActiveStation();
  const date = toDateStr(p.match.datetime) as DateStr;

  const bcrMatchesQuery = useQuery({
    queryKey: ['bcr-matches', station.slug, date],
    queryFn: () =>
      auditReports.executeBcrMatchesReport({
        stationId: station.slug,
        date,
      }),
    enabled: !!date,
  });

  if (!bcrMatchesQuery.data) {
    return null;
  }

  // Check if this match is in the verified array
  // Match by datetime + customId since AuditMatch doesn't have an id
  const isVerified = bcrMatchesQuery.data.verified.some(
    (item: auditReports.BcrMatchesReportVerifiedItemDto) => {
      const match = item.match as auditReports.MatchResultDto;
      return match.datetime === p.match.datetime && match.customId === p.match.audio?.customId;
    },
  );

  if (!isVerified) {
    return null;
  }

  return (
    <Tooltip
      title={$t({
        id: 'audit.bcr.verifiedWithBcr',
        defaultMessage: 'Verificado con BCR',
      })}
    >
      <Chip
        icon={<BroadcastOnPersonalIcon />}
        label={$t({
          id: 'audit.bcr.label',
          defaultMessage: 'BCR',
        })}
        color="info"
        size="small"
        variant="outlined"
      />
    </Tooltip>
  );
}
